/* CliniEco · 族级供应链规划器（5 族共用一套计算，数据从 #cli-pl-data 读）
 * 🔴 价格/装量真值只在 liquid 的 <script type="application/json" id="cli-pl-data">，本文件不写死数字。
 * 红线：无表单/无邮箱门 · 无时效词 · 无疗效词 · 不手写 hreflang
 */
(function () {
  'use strict';

  function readData() {
    var el = document.getElementById('cli-pl-data');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function num(v, d) { var x = parseFloat(v); return isFinite(x) && x > 0 ? x : d; }
  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return list[0]; }
  // 🔴 分区根节点的 id 就是**锚点本身**（#wound-care 等），不是 'cli-pl-<fam>' ——
  //    第一版写成 getElementById('cli-pl-'+fam) ⇒ 找不到 ⇒ render 静默 return ⇒ 计算器全死
  //    （模板元素/按钮/表格都在，静态验收全绿，只有真跑浏览器才发现）。改按 data-fam 找。
  function sectionEl(fam) { return document.querySelector('.cli-pl-section[data-fam="' + fam + '"]'); }

  // 纯函数：便于离线自检
  function compute(vals, item) {
    var usage = 1;
    for (var i = 0; i < vals.length; i++) usage *= vals[i];
    var packs = Math.ceil(usage / item.pack);
    return { usage: Math.round(usage), packs: packs, billed: packs * item.pack, cost: packs * item.price };
  }

  function render(DATA, fam) {
    var cfg = DATA[fam]; if (!cfg) return;
    var box = sectionEl(fam); if (!box) return;
    var out = document.getElementById('cli-pl-' + fam + '-out'); if (!out) return;
    var vals = [], rows = '', missing = false;
    cfg.inputs.forEach(function (inp) {
      var el = document.getElementById('cli-pl-' + fam + '-' + inp.id);
      var v = num(el && el.value, 0);
      if (!v) missing = true;
      vals.push(v);
      rows += '<tr><th>' + inp.label + '</th><td>' + v + '</td></tr>';
    });
    if (missing) {
      out.innerHTML = '<p class="cli-pl-hint">Enter the figures above to see the estimate.</p>';
      return;
    }
    var sel = document.getElementById('cli-pl-' + fam + '-item');
    var item = byId(cfg.items, sel && sel.value);
    if (!item || !item.pack) {
      out.innerHTML = '<p class="cli-pl-hint">Enter the figures above to see the estimate.</p>';
      return;
    }
    var r = compute(vals, item);
    out.innerHTML =
      '<table class="cli-pl-table"><tbody>' + rows +
      '<tr><th>Monthly units needed</th><td><strong>' + r.usage.toLocaleString() + ' ' + item.unit + '</strong></td></tr>' +
      '<tr><th>Order in whole packs / cases</th><td>' + r.packs + ' × pack (' + r.billed.toLocaleString() + ' ' + item.unit + ') @ ' + money(item.price) + '</td></tr>' +
      '<tr><th>Monthly cost (CAD, before tax &amp; shipping)</th><td><strong>' + money(r.cost) + '</strong></td></tr>' +
      '</tbody></table>' +
      '<p class="cli-pl-note">Planning estimate only — not clinical advice. Orders are placed in whole packs/cases. ' +
      'Prices are our website retail prices in CAD and exclude tax and shipping.</p>';
  }

  function printSection(btn) {
    var sec = btn && btn.closest ? btn.closest('.cli-pl-section') : null;
    if (!sec) { window.print(); return; }
    var hidden = [];
    document.querySelectorAll('.cli-pl-section').forEach(function (s) {
      if (s !== sec) { s.classList.add('cli-pl-hide-print'); hidden.push(s); }
    });
    var top = document.getElementById('cli-pl-top');
    if (top) { top.classList.add('cli-pl-hide-print'); hidden.push(top); }
    function cleanup() {
      hidden.forEach(function (e) { e.classList.remove('cli-pl-hide-print'); });
      window.removeEventListener('afterprint', cleanup);
    }
    window.addEventListener('afterprint', cleanup);
    window.print();
    setTimeout(cleanup, 2500);   // 兜底：afterprint 不一定在所有浏览器触发
  }

  function init() {
    if (typeof document === 'undefined') return;
    var DATA = readData();
    Object.keys(DATA).forEach(function (fam) {
      var box = sectionEl(fam);
      if (!box) return;
      DATA[fam].inputs.forEach(function (inp) {
        var el = document.getElementById('cli-pl-' + fam + '-' + inp.id);
        if (!el) return;
        el.addEventListener('input', function () { render(DATA, fam); });
        el.addEventListener('change', function () { render(DATA, fam); });
      });
      var sel = document.getElementById('cli-pl-' + fam + '-item');
      if (sel) sel.addEventListener('change', function () { render(DATA, fam); });
      var pbtn = document.getElementById('cli-pl-' + fam + '-print');
      if (pbtn) pbtn.addEventListener('click', function () { printSection(pbtn); });
      render(DATA, fam);
    });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { compute: compute };
})();
